// extracted by mini-css-extract-plugin
export default {"title":"EditModal_title__bTTx4","infolist":"EditModal_infolist__qHO9A","btnGulp":"EditModal_btnGulp__kpauW","confirm":"EditModal_confirm__0p2d9","cancel":"EditModal_cancel__4amMc"};